import React from "react";
import Step from "./step";

function MethodSet(props) {
  return (
    <div className="recipe-info-group" id="recipe-methods">
      <h5><span className="method-name">{props.methodInfo.methodName}</span></h5>
      {props.methodInfo.yield !== "" ? (
        <h6 id="method-yield">Yield: {props.methodInfo.yield}</h6>
      ) : null}
      {props.methodInfo.process.map((x, index) => {
        return (
          <Step key={x.step} stepNum={x.step} stepDesc={x.stepDescription} />
        );
      })}
    </div>
  );
}

export default MethodSet;
